export enum Locale {
  De_De_H24 = 'de_DE_h24',
  De_At = 'de_AT',
  De_Ch = 'de_CH',
  Fr_Be = 'fr_BE',
  Fr_Ch = 'fr_CH',
  Fr_Fr = 'fr_FR',
  It_It = 'it_IT',
  Nl_Be = 'nl_BE',
  Nl_Nl = 'nl_NL',
}
